import { AfterViewInit, Directive, ElementRef, inject, input } from '@angular/core';
import { DeviceService } from '../services/device-detector/device.service';

@Directive({ selector: '[appAutofocus]' })
export class AutofocusDirective implements AfterViewInit {
  private deviceService = inject(DeviceService);
  private elementRef = inject(ElementRef);

  appAutofocus = input<boolean | string>(true);

  ngAfterViewInit(): void {
    const disableAutofocus = this.appAutofocus() === false || this.appAutofocus() === 'false';

    if (disableAutofocus || !this.deviceService.isPlatformBrowser()) {
      return;
    }

    setTimeout(() => {
      this.elementRef.nativeElement.focus();
    }, 300);
  }
}
